<template>
  <div>
    <div class="label">基础信息</div>
    <el-form label-width="120px">
      <el-form-item label="分类" required>
        <el-select v-model="params.classifyId2" placeholder="请选择">
          <el-option
            :label="item.name"
            :value="item.id"
            :key="item.id"
            v-for="item in labelList"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="命名" required>
        <el-input v-model="params.name"></el-input>
      </el-form-item>
      <el-form-item v-if="type == 61" label="音频" required>
        <el-upload
          accept=".mp3,.wav,.ogg"
          :show-file-list="false"
          action=""
          :before-upload="
            (file) => {
              handleUpload2(file);
              return false;
            }
          "
        >
          <div v-if="params.audioUrl">
            <div>{{ params.audioUrl }}</div>
            <i
              class="el-icon-close"
              @click="params.audioUrl = ''"
              @click.stop=""
            ></i>
          </div>
          <i
            v-else
            class="el-icon-plus avatar-uploader-icon"
            style="font-size: 30px"
          ></i>
        </el-upload>
      </el-form-item>
      <el-form-item :label="type == 61 ? '缩略图' : '图片'" required>
        <el-upload
          accept=".png,.jpg,.jpeg"
          :show-file-list="false"
          action=""
          :before-upload="
            (file) => {
              handleUpload(file);
              return false;
            }
          "
        >
          <div v-if="params.thumbnailImage">
            <img
              :src="params.thumbnailImage | imgFormat"
              class="review-img"
              style="height: auto"
            />
            <i
              class="el-icon-close"
              @click="params.thumbnailImage = ''"
              @click.stop=""
            ></i>
          </div>
          <i
            v-else
            class="el-icon-plus avatar-uploader-icon"
            style="font-size: 30px"
          ></i>
        </el-upload>
      </el-form-item>
    </el-form>
    <div class="lv_flex">
      <el-button type="primary" @click="save(1)">新增并发布</el-button>
      <el-button type="primary" @click="save(2)">存储待发</el-button>
    </div>

    <canvas width="6000" height="10000" id="c" style="display: none"></canvas>
  </div>
</template>

<script>
import Vue from "vue";
export default {
  data() {
    return {
      id: '',
      type: '',
      params: {
        classifyId1: "",
        classifyId2: "",
        classifyId3: "",
        detail: "",
        name: "",
        status: '',
        thumbnailImage: "",
        audioUrl: "", 
        
        coverImage: "",
        basicInfo: "",
        connotation: "",
        collocation: "",
        colorSuggestion: "",
        technicalSuggestion: "",
        allegory: "",
        compositionSuggestion: "",
      },
      form: {},
      labelList: [],
      ossUploadData: {},
    };
  },
  created() {
    this.getLabelList();
    this.getKey();
    this.id = this.$route.query.id || "";
    if (this.id) {
      this.getDetail(this.id);
    }
    this.type = this.$route.query.type || "";
  },
  watch: {
    '$route': {
      handler(newRoute, oldRoute) {
        this.type = newRoute.query.type || "";
        if (this.type) {
          this.params = {
            classifyId1: "",
            classifyId2: "",
            classifyId3: "",
            detail: "",
            name: "",
            status: '',
            thumbnailImage: "",
            audioUrl: "",
          }
          this.getLabelList();
        }
        this.id = newRoute.query.id || "";
        if (this.id) {
          this.params = {
            classifyId1: "",
            classifyId2: "",
            classifyId3: "",
            detail: "",
            name: "",
            status: '',
            thumbnailImage: "",
            audioUrl: "",
          }
          this.getDetail(this.id);
        }
      },
      // 深度监听，确保路由参数变化时也能触发
      deep: true
    }
  },
  methods: {
    getDetail(id) {
      this.$ajax.get("/admin/materialManage/hrss/getById?id=" + id).then((res) => {
        const resData = res.data;
        for (const key in this.params) {
          this.params[key] = resData[key];
        }
      });
    },
    getKey() {
      this.$ajax.post("/user/oss/getKey?pathName=cover").then(async (res) => {
        this.ossUploadData.cover = res.data;
      });

      this.$ajax.post("/user/oss/getKey?pathName=common").then(async (res) => {
        this.ossUploadData.material = res.data;
      });
    },
    //图片轮廓上传成功
    handlePicSuc(file, item) {
      this.getUploadPromise(
        {
          file,
        },
        this.ossUploadData.material
      ).then((res) => {
        const canvas = document.getElementById("c");
        const ctx = canvas.getContext("2d");
        ctx.clearRect(0, 0, c.width, c.height);
        const threeImg = new Image();
        // 改变图片的src
        threeImg.src = Vue.filter("imgFormat")(
          res.addr,
          false,
          "lvshuhualv.oss-cn-hangzhou.aliyuncs.com"
        );
        threeImg.crossOrigin = "Anonymous";
        // 加载完成执行
        threeImg.onload = () => {
          ctx.drawImage(threeImg, 0, 0, threeImg.width, threeImg.height);
          const imgData = ctx.getImageData(
            0,
            0,
            threeImg.width,
            threeImg.height
          );
          const point = [];
          for (let y = 0; y < canvas.height; y++) {
            let test = 0;
            for (let x = 0; x < canvas.width; x++) {
              const i = y * canvas.width + x;
              if (imgData.data[4 * i + 3]) {
                test = x;
              }
            }
            if (test) {
              point.push(test);
            }
          }
          item.points = point;
        };
        item.pointPic = res.addr;
      });
    },
    handleUpload(file) {
      this.getUploadPromise(
        {
          file,
        },
        this.ossUploadData.cover
      ).then((res) => {
        this.params.thumbnailImage = res.addr;
      });
    },
    // 音频上传成功
    handleUpload2(file) {
      this.getUploadPromise(
        {
          file,
        },
        this.ossUploadData.cover
      ).then((res) => {
        console.log(res, "音频上传成功");
        this.params.audioUrl = res.addr;
      });
    },
    //贴图上传成功
    handleUploadSuc(file, item) {
      this.getUploadPromise(
        {
          file,
        },
        this.ossUploadData.material
      ).then((res) => {
        item.map = res.addr;
      });
    },
    getLabelList() {
      this.$ajax.post("/admin/classifyManage/queryAll").then((res) => {
        this.labelList = res.data.find((item) => item.id == this.type).child;
      });
    },
    save(status) {
      this.$ajax
        .post(
          this.id
            ? "/admin/materialManage/hrss/batchUpdate"
            : "/admin/materialManage/hrss/save",
          {
            ...this.params,
            // detail: this.detail.length ? JSON.stringify(this.detail) : "",
            classifyId1: this.type || '61',
            status,
            ids: this.id ? [this.id] : "",
          }
        )
        .then((res) => {
          this.$message.success("保存成功");
          this.$router.push("/mockup/list?type="+ this.type);
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.label {
  font-size: 20px;
  color: #999;
  margin: 15px 0;
}
.model {
  padding: 15px 0;
}

h1 {
  text-align: center;
  font-size: 30px;
  padding: 15px 0;
}

.el-button {
  width: 100%;
}

.review-img {
  height: 150px;
}

.model-item {
  padding: 15px 0;
  border-bottom: 3px solid #000;
}
</style>